import { CalendarAgendaView } from '../calendar/CalendarAgendaView';

export function CalendarView() {
    return <CalendarAgendaView />;
}